import script from "./ReviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewCard.vue?vue&type=script&setup=true&lang=js"

import "./ReviewCard.vue?vue&type=style&index=0&id=47e82937&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e82937"]])

export default __exports__